<!--suppress ALL -->
<template>
  <div class="page">

    <div class="intro-block">
      <div class="bg-left"></div>
      <a class="product-pack"  target="_blank" href="http://espumisan.ru/instructions/espumizan-extra/index.phtml?utm_source=Afisha&utm_medium=Branding&utm_campaign=Espumisan_adults_2018"
         @click="$ga.event('Ссылки', 'Продукт в шапк, внутр', 1)">
        <img src="../assets/img/pack.png" alt=""></a>
      <div class="bg-right"></div>
      <div class="afishaLink">
        <a @click="$ga.event('Ссылка', 'Афиша', 1)" href="https://www.afisha.ru/"  target="_blank"><span class="afisha"></span></a>
      </div>
      <div class="shareBlock" v-if="$resize && $mq.above(768)">
        <share-block></share-block>
      </div>
      <div class="container flex-b-center">
        <div class="photo" data-aos="fade-right">
          <img src="../assets/img/elena/intro.png" alt="">
        </div>
        <div class="info" data-aos="fade-left">
          <router-link to="/" class="back">назад</router-link>
          <h1 class="name">Елена,</h1>
          <h4 class="age">36 лет</h4>
          <div class="line"></div>
          <div class="sub-text">
            После развода Елена решила начать жизнь
            с чистого листа. Переезд и жизнь
            без нервотрепки привели ее сначала
            в тренажерный зал и парикмахерскую, а затем и на собеседование в студию ландшафтного дизайна — наконец
            женщина может вернуться в любимую профессию!
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="content-block">

        <div class="content-block-text" data-aos="fade-up">
          Декрет остался позади, как и желание мужа видеть
          в ней только домохозяйку. Встреча с желанным работодателем чуть-чуть задерживается, и Елене предлагают
          познакомиться с сотрудниками студии.
          <br><br>
          Коллеги встретили соискательницу дружелюбно
          и немедленно решили показать презентации
          с несколькими важными проектами.
        </div>
        <div class="content-block-image" data-aos="fade-down">
          <img src="../assets/img/elena/1.jpg" alt="">
        </div>
      </div>
      <div class="quote" data-aos="flip-left">
        <div class="line"></div>
        <div class="text">Один из возможных коллег — Алексей — явно оказывает больше знаков внимания, чем другие.
        </div>
        <div class="line"></div>
      </div>
      <question :data="this.question1" @correct="()=>{q1=true;AOS.refresh()}" data-aos="fade-left"/>
      <Product data-aos="zoom-in"></Product>
      <div v-if="q1">
        <div class="content-block" data-aos="fade-up">
          <div class="content-block-image">
            <img src="../assets/img/elena/2.jpg" alt="">
          </div>
          <div class="content-block-text">
            Итак, пришел руководитель студии. Обсуждаем мой предыдущий опыт работы. Потенциальный начальник
            заинтересовался одной студией ландшафтного дизайна, где
            я проработала несколько лет, и начинает расспрашивать про нынешнее положение их дел, так как считает их
            конкурентами. Я действительно в курсе, как там дела, потому что дружу
            со многими бывшими коллегами — но стоит ли рассказывать об этом посторонним?

          </div>
        </div>
        <question :data="this.question2" @correct="q2=true" data-aos="fade-right"/>
      </div>
      <div v-if="q2">
        <p>В конце встречи Елену ждал небольшой обмен <br>
          впечатлениями с HR-менеджером студии. </p>
        <div class="quote" data-aos="flip-left">
          <div class="line"></div>
          <div class="text">Во время разговора живот начал предательски урчать (виной тому стал, судя по всему, обед
            с низкокалорийным фасолевым супом), и, как назло, в полной тишине.
          </div>
          <div class="line"></div>
        </div>
        <question :data="this.question3" @correct="q3=true" data-aos="fade-left"/>
      </div>
      <div v-if="q3">
        <ReadMore data-aos="fade-up" :persons="['maria', 'svetlana']"/>
      </div>
    </div>
    <WarningBlock/>
  </div>

</template>

<script>
import "../assets/scss/page.scss";
import ShareBlock from "@/components/ShareBlock.vue";
import Question from "../components/Question";
import Product from "../components/Product";
import ReadMore from "../components/ReadMore";
import WarningBlock from "../components/WarningBlock";

export default {
  name: "Elena",
  mounted() {
    document.body.classList.remove("modal-open");
      this.$ga.event(
          "Страница",
          `Елена`,
          1
      );
  },
  components: {
    ShareBlock,
    Question,
    Product,
    ReadMore,
    WarningBlock
  },
  data() {
    return {
      q1: false,
      q2: false,
      q3: false,
      question1: {
        image: require("../assets/img/elena/q1.png"),
        css: "elena",
        reversed: false,
        n: 1,

        title: "Что делать?",
        variants: [
          {
            title: "1. Конечно!",
            text:
              "Вежливо улыбаться и уделять внимания не больше, \n" +
              "чем остальным",
            correct: true
          },
          {
            title: "2. Кокетничать в ответ",
            text:
              "Кокетничать в ответ, а на прощание втихаря положить на стол Алексею свою визитку.",
            correct: false
          }
        ],
        wrong: {
          title: "Флирт был лишним:",
          text:
            "Алексей был просто вежлив, а в студии он работает в паре со своей невестой. Ей жест с визиткой совсем не понравился, впрочем, как и будущему руководству. Отдел холодно прощается с Еленой и передает боссу, \n" +
            "что такая коллега не подходит коллективу."
        },
        correct: {
          text:
            "Елена показала себя достойно, \n" +
            "отдел с радостью готов поддержать ее кандидатуру"
        }
      },
      question2: {
        image: require("../assets/img/elena/q2.png"),
        css: "elena",
        reversed: true,
        n: 2,
        title: "Как поступить?",
        variants: [
          {
            title: "1. Конечно! ",
            text:
              "Надо рассказать все, что знаешь, — тебе же тут работать. Босс оценит",
            correct: false
          },
          {
            title: "2. Сказать, что ничего не знаешь",
            text: "А если бы и знала, то не сказала бы — это же неэтично",
            correct: true
          }
        ],
        wrong: {
          title: "Это была ловушка",
          text:
            "  Потенциальный начальник не оценил «слив».\n" +
            "        «Сегодня она рассказывает про них, а завтра про нас», — подумал\n" +
            "            он и сказал, что на эту должность Елена не подходит."
        },
        correct: {
          text:
            "Руководитель студии согласился \n" +
            "с Еленой и был рад услышать такой ответ: подлость он не любит"
        }
      },
      question3: {
        image: require("../assets/img/elena/q3.png"),
        css: "elena",
        n: 3,
        reversed: false,
        title: "Что делать?",
        variants: [
          {
            title: "1. Незаметно показать \n" + "на офис-менеджера",
            text: "которая сидела рядом. Это все она!\n",
            correct: false
          },
          {
            title: "2. Извиниться",
            text: "и честно признаться, что это у тебя",
            correct: true
          }
        ],
        wrong: {
          title:
            "Оказалось, что офис-менеджер заметила подлую \n" +
            "попытку Елены обвинить ее в урчании живота, \n" +
            "о чем моментально докладывает эйчару в мессенджере. ",
          text:
            "Та в бешенстве: она ненавидит ложь, но еще больше — \n" +
            "подлость в команде. С аккуратной формулировкой «Вы не совсем подходите на эту позицию» она выпроваживает Елену. "
        },
        correct: {
          text:
            "Эйчар сочувствующе пожала плечами — \n" +
            "со всеми бывает. Разговор закончился выбором \n" +
            "даты для первого рабочего дня",
          style: {
            fontSize: "40px"
          }
        }
      }
    };
  }
};
</script>

<style scoped lang="scss">
  .product-pack{
    top: 13vh;
    right: 2vw;
    left: auto;
  }
.bg-left {
  position: absolute;
  left: 0;
  left: 0;
  top: 0;
  background: url("../assets/img/elena/bg-left.png");
  height: 100%;
  width: 40%;
  background-repeat: no-repeat;
  z-index: -1;
  background-size: contain;
}

.bg-right {
  position: absolute;
  right: 0;
  top: 15%;
  background: url("../assets/img/elena/bg-right.png");
  height: 80%;
  width: 40%;
  background-repeat: no-repeat;
  z-index: -1;
  background-size: contain;
  background-position: top right;
}

.info {
  background-image: url("../assets/img/elena/2.png");
  padding-bottom: 40px;
}

.content-block {
  justify-content: space-between;
  .content-block-text {
    width: 50%;
    line-height: 24px;
    font-size: 17px;
  }
}

@media screen and (max-width: 768px) {
  .bg-left {
    background-image: url("../assets/img/elena/bg-left-m.png");
  }
  .bg-right {
    background-image: url("../assets/img/elena/bg-right-m.png");
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Elena.vue